import { useNavigate } from "react-router-dom";
import Button from "./Button";

export type BlogCardData = {
  id: string;
  title: string;
  image: string;
};

type BlogCardProps = {
  data: BlogCardData;
};

const BlogCard = (props: BlogCardProps) => {
  const navigate = useNavigate();
  const src =
    props.data.image && props.data.image !== "avatar.jpg"
      ? props.data.image
      : "/images/residential-bg.jpg";

  return (
    <div>
      <img
        src={src}
        alt=""
        className="w-full h-80 object-cover object-center rounded-xl mb-3"
      />
      <p className="text-lg text-white font-bold mb-3 line-clamp-2">
        {props.data.title}
      </p>
      <Button
        variant="hover-light"
        onClick={() => navigate(`/blogs/${props.data.id}`)}
      >
        Read More
      </Button>
    </div>
  );
};

export default BlogCard;
